export const flowImageZH = {
  flowImage1: 'https://img.webloom.cn/img/5de2b6f2259be372833e01015fd59e12.png',
  // flowImage2: 'https://img.webloom.cn/img/PC报名咨询-中文.svga',
  // flowImage2: 'https://img.webloom.cn/Img/kefuiconEn.svga',
  flowImage2: 'https://img.webloom.cn/Img/kefuCn.svga',
  flowImage3: 'https://img.webloom.cn/img/PC-已使用.png',
  flowImage4: 'https://img.webloom.cn/img/PC-已失效.png',
  flowImage5: 'https://img.webloom.cn/img/pingtai_ban.png',
  flowImage6: 'https://img.webloom.cn/img/pingtai_def.png',
  flowImage7: 'https://img.webloom.cn/img/shangpin_ban.png',
  flowImage8: 'https://img.webloom.cn/img/shangpin_def.png',
  flowImage9: 'https://img.webloom.cn/img/d0a3bf611c09ffadedd25e0c59ef2f28.png',
  flowImage10: 'https://img.webloom.cn/img/91d52eb77d59c8cac356f2f7030be52a.png',
  flowImage11: 'https://img.webloom.cn/img/syhot.png',
  flowImage12: 'https://img.webloom.cn/img/erCode2.png',
  flowImage13: 'https://img.webloom.cn/img/concantusadress.png',
  flowImage14: 'https://img.webloom.cn/img/stepCN1.png',
  flowImage15: 'https://img.webloom.cn/img/stepCN4.png',
  flowImage16: 'https://img.webloom.cn/img/stepCN2.png',
  flowImage17: 'https://img.webloom.cn/img/stepCN3.png',
  flowImage18: 'https://img.webloom.cn/img/seal.png',
  flowImage19: 'https://img.webloom.cn/img/h5_syBaominzhon.png',
  flowImage20: 'https://img.webloom.cn/img/share.c66567f.png'
}

export const flowImageEN = {
  flowImage1: 'https://img.webloom.cn/img/12.分享成绩.png',
  // flowImage2: 'https://img.webloom.cn/img/help.svga',
  flowImage2: 'https://img.webloom.cn/Img/kefuEn.svga',
  flowImage3: 'https://img.webloom.cn/img/3.已使用.png',
  flowImage4: 'https://img.webloom.cn/img/4.已失效.png',
  flowImage5: 'https://img.webloom.cn/img/7.平台券-失效.png',
  flowImage6: 'https://img.webloom.cn/img/7.平台券-默认.png',
  flowImage7: 'https://img.webloom.cn/img/6.商品券-失效.png',
  flowImage8: 'https://img.webloom.cn/img/6.商品券-默认.png',
  flowImage9: 'https://img.webloom.cn/img/13.分享到团队主页-默认png.png',
  flowImage10: 'https://img.webloom.cn/img/13.分享到团队主页-点击.png',
  flowImage11: 'https://img.webloom.cn/img/18.报名进行中.png',
  flowImage12: 'https://img.webloom.cn/img/erCodeMore1.png',
  flowImage13: 'https://img.webloom.cn/img/concantusadress.png',
  flowImage14: 'https://img.webloom.cn/img/stepEN1.png',
  flowImage15: 'https://img.webloom.cn/img/stepEN2.png',
  flowImage16: 'https://img.webloom.cn/img/stepEN3.png',
  flowImage17: 'https://img.webloom.cn/img/stepEN4.png',
  flowImage18: 'https://img.webloom.cn/img/5.加入成功.png',
  flowImage19: 'https://img.webloom.cn/img/18.报名进行中.png',
  flowImage20: 'https://img.webloom.cn/img/paySuccess1.png'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/image.js